module.exports = "https://web-assets.ifttt.com/packs/media/social-signon/facebook_white_svg-3d856a73.svg";